/**
 * svgtoreact
 *
 * @author Michael Hsu
 */

import React from 'react';

export default function SVGManagement(props) {
  return (
    <svg width={42} height={32} viewBox="0 0 42 32" {...props}>
      <g fill="none">
        <path d="M-9-14h60v60h-60z" />
        <path
          d="M2.5 25.991v4.018c0 .267.223.491.491.491h4.018c.267 0 .491-.223.491-.491v-4.018c0-.267-.223-.491-.491-.491h-4.018c-.267 0-.491.223-.491.491zm-1 0c0-.821.673-1.491 1.491-1.491h4.018c.821 0 1.491.673 1.491 1.491v4.018c0 .821-.673 1.491-1.491 1.491h-4.018c-.821 0-1.491-.673-1.491-1.491v-4.018zm13.5 2.509c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h26c.276 0 .5.224.5.5s-.224.5-.5.5h-26zm-12.5-12.509v4.018c0 .267.223.491.491.491h4.018c.267 0 .491-.223.491-.491v-4.018c0-.267-.223-.491-.491-.491h-4.018c-.267 0-.491.223-.491.491zm-1 0c0-.821.673-1.491 1.491-1.491h4.018c.821 0 1.491.673 1.491 1.491v4.018c0 .821-.673 1.491-1.491 1.491h-4.018c-.821 0-1.491-.673-1.491-1.491v-4.018zm13.5 2.509c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h26c.276 0 .5.224.5.5s-.224.5-.5.5h-26zm-13.208-14.511l3.304 4.282 5.065-7.815c.3-.463.92-.596 1.383-.295.463.3.596.92.295 1.383l-5.285 8.153c-.68 1.049-2.033 1.104-2.794.117l-3.552-4.603c-.337-.437-.256-1.065.181-1.403.437-.337 1.065-.256 1.403.181zm13.208 4.511c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h26c.276 0 .5.224.5.5s-.224.5-.5.5h-26z"
          fill="#fff"
        />
      </g>
    </svg>
  );
}



// WEBPACK FOOTER //
// ./src/components/SVG/SVGManagement.js